import { useSelector } from "react-redux";
import { QuizType } from "../quizType/QuizType";
import { CompanyData } from "../companyData/CompanyData";
import { Question } from "../question/Question";
import { questionsArray } from "../../questions";
import { useEffect, useState } from "react";
import { questionsArrayNo } from "../../questionsNo";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function QuestionsContainer() {
  const { currentLevel, quizType, level, language } = useSelector(
    (state) => state.global
  );

  const pageText = language === "en" ? translations : translationsNo;

  function whichLevelDescription(level) {
    switch (level) {
      case -2:
        return pageText.titles.title1;
      case -1:
        return pageText.titles.title2;
      case 0:
        return pageText.titles.title2;
      case 1:
        return filteredData[0]?.title;
      default:
        break;
    }
  }

  const questions = language === "en" ? questionsArray : questionsArrayNo;

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    // Filter questions based on both level and quiz type.
    const levelFilteredData = questions.filter((q) => q.level === level);
    const typeFilteredData =
      quizType === "short"
        ? levelFilteredData.filter((q) => q.version === "short")
        : levelFilteredData.filter((q) => q.version === "long");

    setFilteredData(typeFilteredData);
  }, [level, quizType, language]);

  return (
    <div>
      <div id="quiz-level-description">
        {whichLevelDescription(currentLevel)}
      </div>
      <div id="quiz-level" className="quiz-content">
        {currentLevel === -2 && <QuizType />}
        {currentLevel === -1 && <CompanyData />}
        {currentLevel === 0 && <CompanyData />}
        {currentLevel === 1 &&
          filteredData.map((q, index) => (
            <Question
              key={index}
              question={q.question}
              options={q.options}
              customFieldId={index}
              questionId={q.id}
            />
          ))}
      </div>
    </div>
  );
}
